import { Component, computed, inject, signal } from '@angular/core';
import { ExperienceLink, ExperienceModel } from 'src/app/models/experience-link';
import { BookclubLinksDialogFacade } from 'src/app/_core/state/dialogs/bookclub-links/bookclub-links.facade';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'opac-bookclub-links-dialog',
  templateUrl: './bookclub-links-dialog.component.html',
  styleUrls: ['./bookclub-links-dialog.component.scss'],
})
export class BookclubLinksDialogComponent {
  readonly MAX_SIZE_EXPERIENCES = 4;

  private readonly bookclubLinksDialogFacade = inject(BookclubLinksDialogFacade);

  readonly open = toSignal<boolean>(this.bookclubLinksDialogFacade.open$);
  readonly title = toSignal<string>(this.bookclubLinksDialogFacade.title$);
  readonly links = toSignal<ExperienceModel[]>(this.bookclubLinksDialogFacade.links$);
  readonly resourceId = toSignal<string>(this.bookclubLinksDialogFacade.resourceId$);

  readonly checked = signal<boolean>(false);

  sendBookClubHistory(link: ExperienceLink) {
    this.bookclubLinksDialogFacade.sendBookClubHistory(this.resourceId(), link, this.checked()).subscribe();
  }

  closeDialog() {
    this.bookclubLinksDialogFacade.closeDialog();
  }
}
